var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoEmailsNotificationService = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_4_",
    "data-name": "mail (4)",
    transform: "translate(0 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29070",
    "data-name": "Group 29070",
    transform: "translate(12.382 76.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29069",
    "data-name": "Group 29069"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48369",
    "data-name": "Path 48369",
    d: "M357.67,101.721l-5.459,5.571,5.459,5.571a1.642,1.642,0,0,0,.159-.7v-9.75A1.642,1.642,0,0,0,357.67,101.721Z",
    transform: "translate(-352.211 -101.721)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29072",
    "data-name": "Group 29072",
    transform: "translate(.904 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29071",
    "data-name": "Group 29071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48370",
    "data-name": "Path 48370",
    d: "M41.235,76H26.4a1.53,1.53,0,0,0-.678.163L32.7,83.293a1.554,1.554,0,0,0,2.237,0l6.977-7.131A1.53,1.53,0,0,0,41.235,76Z",
    transform: "translate(-25.721 -76)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29074",
    "data-name": "Group 29074",
    transform: "translate(0 76.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29073",
    "data-name": "Group 29073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48371",
    "data-name": "Path 48371",
    d: "M.159,101.721a1.642,1.642,0,0,0-.159.7v9.75a1.642,1.642,0,0,0,.159.7l5.459-5.571Z",
    transform: "translate(0 -101.721)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29076",
    "data-name": "Group 29076",
    transform: "translate(.904 83.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29075",
    "data-name": "Group 29075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48372",
    "data-name": "Path 48372",
    d: "M36.453,277.211l-.772.793a2.59,2.59,0,0,1-3.728,0l-.772-.793-5.459,5.571a1.53,1.53,0,0,0,.678.163H41.235a1.53,1.53,0,0,0,.678-.163Z",
    transform: "translate(-25.721 -277.211)",
    fill: "#999"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoEmailsNotificationService);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_emails_notification_service.4a5e174c45c38b5e0a0b1096ecc4fbb8.svg";